<template>
  <v-container class="h-100 pa-4" fluid>
    <v-row justify="center" class="h-100">
      <v-sheet class="bg-background flex-1-1 px-4" max-width="600">
        <div class="text-h5 text-center mb-8 font-weight-medium">404 - Page Not Found</div>
        <p>The page you are looking for does not exist.</p>
        <router-link to="/">Go Home</router-link>
      </v-sheet>
    </v-row>
  </v-container>
</template>
